import { withRouter } from "react-router-dom"
import React from "react"

const Gallery = () => {
    const image_1 = require("../../assets/galleryImages/photo1.jpg")
    const image_2 = require("../../assets/galleryImages/photo2.jpg")
    const image_3 = require("../../assets/galleryImages/photo3.jpg")
    const image_4 = require("../../assets/galleryImages/photo4.jpg")
    const image_5 = require("../../assets/galleryImages/photo5.jpg")
    const image_6 = require("../../assets/galleryImages/photo6.jpg")
    const image_7 = require("../../assets/galleryImages/photo7.jpg")
    const image_8 = require("../../assets/galleryImages/photo8.jpg")
    const image_9 = require("../../assets/galleryImages/photo9.jpg")
    const image_10 = require("../../assets/galleryImages/photo10.jpg")
    const image_11 = require("../../assets/galleryImages/photo11.jpg")
    const image_12 = require("../../assets/galleryImages/photo12.jpg")
    const image_13 = require("../../assets/galleryImages/photo13.jpg")
    const image_14 = require("../../assets/galleryImages/photo14.jpg")
    const image_15 = require("../../assets/galleryImages/photo15.jpg")
    const image_16 = require("../../assets/galleryImages/photo16.jpg")
    const image_17 = require("../../assets/galleryImages/photo17.jpg")
    const image_18 = require("../../assets/galleryImages/photo18.jpg")
    const image_19 = require("../../assets/galleryImages/photo19.jpg")
    const image_20 = require("../../assets/galleryImages/photo20.jpg")
    const image_21 = require("../../assets/galleryImages/photo21.jpg")
    const image_22 = require("../../assets/galleryImages/photo22.jpg")
    const image_23 = require("../../assets/galleryImages/photo23.jpg")

    //TODO Refactor
    return (
        <div>
            <div className="row">
                <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
                    <img
                        src={image_1.default}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="image_1"
                    />
                </div>

                <div className="col-lg-4 mb-4 mb-lg-0">
                    <img
                        src={image_2.default}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="image_2"
                    />
                </div>

                <div className="col-lg-4 mb-4 mb-lg-0">
                    <img
                        src={image_3.default}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="image_3"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
                    <img
                        src={image_4.default}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="image_4"
                    />
                </div>

                <div className="col-lg-4 mb-4 mb-lg-0">
                    <img
                        src={image_5.default}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="image_5"
                    />
                </div>

                <div className="col-lg-4 mb-4 mb-lg-0">
                    <img
                        src={image_6.default}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="image_6"
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
                    <img
                        src={image_7.default}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="image_7"
                    />
                </div>

                <div className="col-lg-4 mb-4 mb-lg-0">
                    <img
                        src={image_8.default}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="image_8"
                    />
                </div>

                <div className="col-lg-4 mb-4 mb-lg-0">
                    <img
                        src={image_9.default}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="image_9"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
                    <img
                        src={image_10.default}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="image_10"
                    />
                </div>

                <div className="col-lg-4 mb-4 mb-lg-0">
                    <img
                        src={image_11.default}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="image_11"
                    />
                </div>

                <div className="col-lg-4 mb-4 mb-lg-0">
                    <img
                        src={image_12.default}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="image_12"
                    />
                </div>

            </div>

            <div className="row">
                <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
                    <img
                        src={image_13.default}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="image_13"
                    />
                </div>

                <div className="col-lg-4 mb-4 mb-lg-0">
                    <img
                        src={image_14.default}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="image_14"
                    />
                </div>

                <div className="col-lg-4 mb-4 mb-lg-0">
                    <img
                        src={image_15.default}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="image_15"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
                    <img
                        src={image_16.default}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="image_16"
                    />
                </div>

                <div className="col-lg-4 mb-4 mb-lg-0">
                    <img
                        src={image_17.default}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="image_17"
                    />
                </div>

                <div className="col-lg-4 mb-4 mb-lg-0">
                    <img
                        src={image_18.default}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="image_18"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
                    <img
                        src={image_19.default}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="image_19"
                    />
                </div>

                <div className="col-lg-4 mb-4 mb-lg-0">
                    <img
                        src={image_20.default}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="image_20"
                    />
                </div>

            </div>

            <div className="row">
                <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
                    <img
                        src={image_21.default}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="image_21"
                    />
                </div>

                <div className="col-lg-4 mb-4 mb-lg-0">
                    <img
                        src={image_22.default}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="image_22"
                    />
                </div>

                <div className="col-lg-4 mb-4 mb-lg-0">
                    <img
                        src={image_23.default}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="image_23"
                    />
                </div>
            </div>

        </div>
    )
}

export default withRouter(Gallery)